import { defineStore } from 'pinia';
import { toRaw } from 'vue';
import { reorderNodeOutputs } from '../graph/graphModel.js';
import { hassDomain } from '../hass/hassDomain.js';
import { graphStoreOptions } from './graphStoreOptions.js';

/**
 * Editor state for the Home Assistant flow graph, and the only place that
 * mutates `page.hass` on behalf of the user. Every mutation goes through
 * history (a GraphCommand in the `homeassistant` category). The generic part
 * (selection, placement, connect, delete, …) is shared with the other graph
 * domains; see graphStoreOptions. The graph shows in Home Assistant mode.
 */
export const useHassFlowStore = defineStore('hassFlow', graphStoreOptions(hassDomain, {
    actions: {
        /** Rewrite the execution order of a trigger's or condition's outgoing wires. */
        reorderRunWires(page, nodeId, wireIds) {
            page = toRaw(page);
            this.commit(page, reorderNodeOutputs(page.hass, nodeId, wireIds), 'Reorder actions');
        },
    },
}));
